module.exports = {
      id: "symbol-ACE_Logo-usage",
      viewBox: "0 0 106 43",
      url: __webpack_public_path__ + "sprite.svg#symbol-ACE_Logo-usage",
      toString: function () {
        return this.url;
      }
    }